@if (dataLoaded) {

  @if (showErrorState) {
    <div class="error-state-alignment illustration">
      <span class="themed-illustration" [innerHTML]="themedSvgHtml"></span>
      <div class="page-title" style="padding-top: 32px">Service currently unavailable</div>
      <div>Please refresh or try again later</div>
    </div>
  }
  @else if (showEmptyState) {
    <div class="empty-state">No information to display</div>
  }
  @else {
    @if (availableFilters.length) {
      <div class="filter-container">
        <div class="filter-label">Filter by</div>
        <mat-chip-set class="basic-table-filters" aria-label="Table filters">
          <mat-chip-option [selected]="isFilterSelected('ALL')" [selectable]="true" [removable]="false" (click)="toggleFilter('ALL')">All</mat-chip-option>
          @for (filter of availableFilters; track filter) {
            <mat-chip-option [selected]="isFilterSelected(filter)" [selectable]="true" [removable]="false" (click)="toggleFilter(filter)">{{filter | constantPretty}}</mat-chip-option>
          }
        </mat-chip-set>
      </div>
    }

    <div class="table-scroll-container">
      <table mat-table matSort [matSortActive]="defaultSortColumn" matSortDirection="desc" [dataSource]="dataSource">

        @for (column of orderedColumns; track column.orderIndex) {
          <ng-container [matColumnDef]="getColumnName(column)">
            <th mat-header-cell [ngClass]="getColumnClass(column)" *matHeaderCellDef
                mat-sort-header [disabled]="column.sortDisabled">{{column.header}}</th>
            <td mat-cell *matCellDef="let row">
              @switch (column.type) {
                @case ('TEXT') {
                  @if (column.dataField) {
                    @let cellStyle = getCellStyle(row, column);

                    <span
                      class="dynamic-material-table-cell-value"
                      [style.color]="cellStyle?.color"
                      [style.font-weight]="cellStyle?.isBold ? '700' : null"
                      [style.font-style]="cellStyle?.isItalic ? 'italic' : null"
                      [style.text-decoration]="cellStyle?.isUnderlined ? 'underline' : null">
                      {{getCellValue(row, column)}}
                    </span>
                  }
                }
                @case ('DATE') {
                  @if (column.dataField) {
                    @let cellStyle = getCellStyle(row, column);

                    <span
                      class="dynamic-material-table-cell-value"
                      [style.color]="cellStyle?.color"
                      [style.font-weight]="cellStyle?.isBold ? '700' : null"
                      [style.font-style]="cellStyle?.isItalic ? 'italic' : null"
                      [style.text-decoration]="cellStyle?.isUnderlined ? 'underline' : null">
                      {{getCellValue(row, column) | date: 'dd MMM yyyy'}}
                    </span>
                  }
                }
                @case ('PHONE_NUMBER') {
                  @if (column.dataField) {
                    @let cellStyle = getCellStyle(row, column);

                    <span
                      class="dynamic-material-table-cell-value"
                      [style.color]="cellStyle?.color"
                      [style.font-weight]="cellStyle?.isBold ? '700' : null"
                      [style.font-style]="cellStyle?.isItalic ? 'italic' : null"
                      [style.text-decoration]="cellStyle?.isUnderlined ? 'underline' : null">
                      {{getCellValue(row, column) | phoneNumber}}
                    </span>
                  }
                }
                @case ('SINGLE_ACTION') {
                  @if (column.actions) {
                    <button mat-icon-button type="button" (click)="executeAction(column.actions[0], row)">
                      <mat-icon>{{column.actions[0]?.icon}}</mat-icon>
                    </button>
                  }
                }
                @case ('MULTI_ACTION') {

                }
              }
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }
}
